var userAgent = require('../internals/engine-user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-is-ios.js
// module id = 170
// module chunks = 0 1 5 7 8 9 25